export const getPriceCalculatorRoute = () => {
  return '/price-calculator/consignments';
};
